import type { ActiveBooleanFeatureFlag } from "@/types/ActiveFeatureFlag";

export const ABANDONED_CHECKOUT_PROMO_OFFER_ID = "abandoned-checkout";

export const ABANDONED_CHECKOUT_PROMO_OFFER = {
  percentOff: 10,
  code: "START10",
} as const;

/**
 * Release toggle for the whole promo, banner and auto-apply alike (R-2430).
 * Off in PostHog until the Black Friday campaign: coupon use had outgrown the
 * new paying users it was meant to bring in, so the offer is paused rather
 * than removed, and switching the flag on brings it back without a deploy.
 */
export const ABANDONED_CHECKOUT_PROMO_FLAG =
  "abandoned_checkout_promo" satisfies ActiveBooleanFeatureFlag;
